import { useTranslate } from "@refinedev/core";
import { Grid2 as Grid } from "@mui/material";

import { Form } from "@shared/components";

export function IntegrationFields() {
  const translate = useTranslate();

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Select
          name="integration_id"
          label={translate("v1/agreement_admin.fields.integration")}
          options={[
            { value: "nação", label: "Flamengo" },
            { value: "tim", label: "Tim" },
            { value: "ixc", label: "IXC" },
            { value: "mk", label: "MK" },
            { value: "sgp", label: "SGP" },
            { value: "playhub", label: "Playhub" },
            { value: "dtel", label: "Dtel" },
            { value: 'rbx', label: 'RBX' },
            { value: "elite", label: "Elite" },
            { value: "easy", label: "Easy" },
            { value: "top", label: "Top" },
            { value: "itnet", label: "ItNet" },
            { value: "az", label: "7az" },
            { value: "youcast!", label: "youcast" },
            { value: "duobox", label: "duobox" },
            { value: "gfsis", label: "GFsis" },
            { value: "neo", label: "NEO" },
            { value: "certirio", label: "Certirio" },
            { value: "isuper", label: "iSuper" },
            { value: "voalle", label: "Voalle" },
            { value: "hubsoft", label: "Hubsoft" },
            { value: "sercomtel", label: "Sercomtel" },
            { value: "altarede", label: "Altarede" },
            { value: "voalleThird", label: "Voalle Third" },
          ]}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="integration_id"
          label={translate("v1/agreement_admin.fields.integration_id")}
          instructions="Exemplos aplicaveis: mk,isuper,certirio,ixc,itnet,voalle,hubsoft,sercomtel,maxx,leste,gfsis,playhub,top,sgp,az"
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Switch
          name="is_default_agreement"
          label={translate("v1/agreement_admin.fields.is_default_agreement")}
          instructions="Convênio Partiu"
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="integration_host"
          label={translate("v1/agreement_admin.fields.integration_host")}
          instructions="No formato https://integrador.com.br"
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="integration_client_id"
          label={translate("v1/agreement_admin.fields.integration_client_id")}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="integration_token"
          label={translate("v1/agreement_admin.fields.integration_token")}
          instructions="No formato jhziux23a-12312jnash-zkxchzox123-aslkdj123"
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="integration_token2"
          label={translate("v1/agreement_admin.fields.integration_token2")}
          instructions="No formato jhziux23a-12312jnash-zkxchzox123-aslkdj123"
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="integration_name"
          label={translate("v1/agreement_admin.fields.integration_name")}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          type="password"
          name="integration_password"
          label={translate("v1/agreement_admin.fields.integration_password")}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="integrated_login"
          label={translate("v1/agreement_admin.fields.integrated_login")}
          instructions="Playhub, youcast, neo, etc..."
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <Form.Input
          name="idp"
          label={translate("v1/agreement_admin.fields.idp")}
          instructions="ISP, whitelabel para NEO, Playhub, etc..."
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Switch
          name="integration_special_case"
          label={translate("v1/agreement_admin.fields.integration_special_case")}
          instructions="Cliente obrigado a ter pacote Partiu na Hubsoft"
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Switch
          name="can_use_dataless_integration"
          label={translate("v1/agreement_admin.fields.can_use_dataless_integration")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Switch
          name="third_party_login"
          label={translate("v1/agreement_admin.fields.third_party_login")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="chat_widget_script"
          label={translate("v1/agreement_admin.fields.chat_widget_script")}
          instructions="Cole o <script> do widget (ex.: wts.chat). Ele é carregado no super app deste convênio."
          multiline
          minRows={3}
        />
      </Grid>

    </Grid>
  );
}
